export class ToggleDarkMode {
  static readonly type = '[UI] Toggle DarkMode';
  constructor(public isDarkMode: boolean) {}
}
